import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Layout } from "antd";
import { Title } from "../../Utils/UI/Text";
import { getNfts } from "../Application/Nfts.business";
import NftsBoard from "./NftsBoard";
import {
  getNftsSelector,
  getNftsCountSelector,
} from "../Infrastructure/Nfts.reducer";
const { Content } = Layout;

export default function Nfts() {
  const nftsData = useSelector(getNftsSelector);
  const totalCount = useSelector(getNftsCountSelector);
  useEffect(() => {
    getNfts();
  }, []);

  return (
    <Content >
      <Title children="Token Activity (NFTs)" />

      <NftsBoard
        nftsData={nftsData}
        getNfts={getNfts}
        totalCount={totalCount}
      />
    </Content>
  );
}
